import { useState, useEffect } from "react";
import msTeamsMeetingAppFrameEnum from "../enum/msTeamsMeetingAppFrameEnum";
import * as msTeams from "@microsoft/teams-js";
import { getCurrentInMeetingAppStageByFrameContext } from "../utils/msTeamsInMeetingUtils";

export interface MsTeamsInMeetingAppContext {
    meetingId: string;
    meetingStage: msTeamsMeetingAppFrameEnum;
}

export const useMsTeamsInMeetingApps = () => {
    const [meetingId, setMeetingId] = useState("");
    const [currentMeetingStage, setCurrentMeetingStage] = useState(msTeamsMeetingAppFrameEnum.beforeMeeting);

    useEffect(() => {
        const init = async () => {
            await msTeams.app.initialize();
            const teamsContext = await msTeams.app.getContext();
            setMeetingId(teamsContext.meeting!.id);
            setCurrentMeetingStage(getCurrentInMeetingAppStageByFrameContext(teamsContext.page.frameContext));
        };
        init();
    }, []);

    return {
        meetingId: meetingId,
        meetingStage: currentMeetingStage,
    };
};
